import type { Params, Score, Template } from '../score';
import { AURORA } from './aurora';
import { BATERIA } from './bateria';
import { CARIMBO } from './carimbo';
import { CHIP } from './chip';
import { CHUVA } from './chuva';
import { COGUMELOS } from './cogumelos';
import { CRISTAIS } from './cristais';
import { DISCO } from './disco';
import { DREAM } from './dream';
import { DUB } from './dub';
import { EDM } from './edm';
import { SPOOKY } from './spooky';
import { FORRO } from './forro';
import { FREVO } from './frevo';
import { FUNK } from './funk';
import { HOUSE } from './house';
import { LANTERNAS } from './lanternas';
import { LOFI } from './lofi';
import { MARACATU } from './maracatu';
import { PHONK } from './phonk';
import { POP } from './pop';
import { RELOJOARIA } from './relojoaria';
import { SAMBA } from './samba';
import { SAMBAREGGAE } from './sambareggae';
import { TRAP } from './trap';
import { XOTE } from './xote';

export const TEMPLATES: readonly Template[] = [HOUSE, TRAP, LOFI, FORRO, DREAM, MARACATU, SAMBAREGGAE, POP, DISCO, FUNK, EDM, PHONK, CARIMBO, FREVO, CHIP, RELOJOARIA, XOTE, DUB, SPOOKY, BATERIA, SAMBA, CHUVA, COGUMELOS, CRISTAIS, LANTERNAS, AURORA];

export function templateOf(id: string): Template {
  const t = TEMPLATES.find((x) => x.id === id);
  if (t === undefined) throw new Error(`no template ${id}`);
  return t;
}

export const refIds: readonly string[] = TEMPLATES.map((t) => `${t.id}-${t.ref.seed}`);

export type TrackSpec = { template: string; seed: string; params: Params };

export function parseTrack(spec: string): TrackSpec {
  const [template, seed, bpm, bars, energy] = spec.split(':');
  if (template === undefined || seed === undefined || seed === '' || bpm === undefined || bars === undefined) {
    throw new Error(`bad track ${spec} (want template:seed:bpm:bars[:energy])`);
  }
  const params: Params = { bpm: Number(bpm), bars: Number(bars), energy: energy === undefined ? 0.7 : Number(energy) };
  if (![params.bpm, params.bars ?? 0, params.energy].every(Number.isFinite)) throw new Error(`bad track ${spec}`);
  templateOf(template);
  return { template, seed, params };
}

export function scoreOf(id: string): Score {
  if (id.includes(':')) {
    const t = parseTrack(id);
    return templateOf(t.template).score(t.seed, t.params);
  }
  const t = TEMPLATES.find((x) => id === `${x.id}-${x.ref.seed}`);
  if (t === undefined) throw new Error(`no track ${id}`);
  return t.score(t.ref.seed, t.ref.params);
}
